import { useEffect, useRef } from "react";

import "./ServiceDescription.css";

import Link from "../../_components/link/Link";
import SectionHeader from "../../_components/section-header/SectionHeader";
import createAnimation from "../../_utils/createAnimation";

const ServiceDescription = ({ id, name, description, image, link, i }) => {
  const ref = useRef(null);
  useEffect(() => createAnimation(ref), []);

  const label =
    name === "Group sessions" ? "Join a group" : "Book a free session";
  return (
    <section
      className={`ServiceDescription${i % 2 ? " reverse" : ""}`}
      ref={ref}
      id={id}
    >
      <img src={image} alt="" />
      <aside className="ServiceDescription-description">
        <SectionHeader small text={name} />
        <article>{description}</article>
        <Link primary ariaLabel={`Click here to ${label}`} link={link}>
          {label}
        </Link>
      </aside>
    </section>
  );
};

export default ServiceDescription;
